import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import './utils/posthog';

const container = document.getElementById('root')!;

const AnyProvider: any = Provider;

createRoot(container).render(
  <React.StrictMode>
    <Router>
      <AnyProvider store={store}>
        <App />
      </AnyProvider>
    </Router>
  </React.StrictMode>
);
